<template>
    <div class=" mt-16 bg-[#F6F6F6]">
        <swiper :pagination="pagination" :modules="modules" :preventClicks="false" :allowTouchMove="false"
            :autoHeight="true" :id="`slider-content-${path}`" class="scroll-mt-[10rem]">
            <swiper-slide v-for="(content, index) in tabs" :key="index">
                <ContentRenderer :value="content">
                    <span class="font-bold text-2xl py-8 noSwipingClass">{{ content.title_inside || content.title
                        }}</span>
                    <span class="block mt-4">{{ content.description }}</span>
                    <ContentRendererMarkdown :value="content" />
                </ContentRenderer>
            </swiper-slide>
        </swiper>
    </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination, HashNavigation } from 'swiper/modules'
const props = defineProps({
    usecases: Array
})

const data = await queryContent(`/solutions/_usecases`).where({ _partial: true }).find()

const tabs = data.filter((page) => {
    const fileName = page._path.split('/').at(-1).toLowerCase()

    return props.usecases.includes(fileName)
}).sort((a, b) => {
    const fileNameA = a._path.split('/').at(-1).toLowerCase()
    const fileNameB = b._path.split('/').at(-1).toLowerCase()
    return props.usecases.indexOf(fileNameA) - props.usecases.indexOf(fileNameB)
})

if (!tabs.length) {
    throw Error("Inappropriate or no showcase names for showcase slider")
}

const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
        return `<span class="${className}"> ${tabs[index].title} </span>`
    }
}
const modules = [Pagination, HashNavigation]

// const route = useRoute()
// onMounted(async () => {
//     if (route.hash) {
//         console.log("HASH", route)
//         await nextTick()
//         document.getElementById(`slider-content-${props.path}`).scrollIntoView({ block: 'center', behavior: 'smooth' })
//     }
// })

</script>

<style scoped>
::v-deep(.swiper-pagination) {
    position: absolute;
    left: 0px !important;
    top: 0px !important;
    width: auto !important;
    height: 2rem;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem 0;
}

::v-deep(.swiper-pagination-bullet) {
    padding: 1rem 1rem;
    border-radius: 0;
    width: max-content;
    line-height: 0;
    text-align: center;
    font-size: 1rem;
    color: #000;
    background-color: #fff;
    z-index: 1;
    opacity: 0.9;
}

::v-deep(.swiper-pagination-bullet-active) {
    color: #fff;
    background: #1C1CF0 !important;
    font-weight: bold;
}

::v-deep(.swiper-wrapper) {
    height: fit-content;

}

.swiper-container {
    width: 100%;

}

.swiper-slide {
    display: block;
    padding: 2rem;
    width: 100%;
    height: fit-content;
    padding-top: 5rem;
}

@media (max-width: 600px) {
    .swiper-slide {
        padding-top: 8rem;
    }
}
</style>
